var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KnowledgeWorkspace',{attrs:{"editorial":"","editor-component":_vm.TextEditor,"project":_vm.project,"send":_vm.send,"article-id":_vm.$route.params.id,"source-visit":_vm.$route.query.visit,"create-on-open":_vm.$route.query.create === '1'},on:{"open":_vm.open,"list":_vm.list,"all":_vm.all,"visit":_vm.visit}})
}
var staticRenderFns = []

export { render, staticRenderFns }